function applyNumpad (el, binding) {
  const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
  if (!input) return

  const mode = (binding && binding.value) || 'numeric'
  input.setAttribute('inputmode', mode)
  input.setAttribute('enterkeyhint', 'done')
  input.setAttribute('autocomplete', 'off')
  input.setAttribute('autocorrect', 'off')
  input.setAttribute('autocapitalize', 'off')
  input.setAttribute('spellcheck', 'false')

  if (mode === 'numeric' || mode === 'tel' || mode === 'decimal') {
    input.setAttribute('pattern', mode === 'decimal' ? '[0-9]*[.,]?[0-9]*' : '[0-9]*')
    // tel → iOS/Android numpad without browser number steppers
    input.type = 'tel'
  }
}

export default {
  inserted (el, binding) {
    applyNumpad(el, binding)
    requestAnimationFrame(() => applyNumpad(el, binding))
  },
  componentUpdated (el, binding) {
    applyNumpad(el, binding)
  }
}
